export default __webpack_public_path__ + "static/media/122.2fc31000.jpg";